module.exports = __webpack_public_path__ + "img/sqjk.5b6efc59.png";